var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImg3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 258,
    viewBox: "0 0 227 258",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.182 212.534C177.598 164.186 133.245 150.441 190.916 103.947L225.22 76.2905L164.52 1C164.52 1 161.951 2.32707 129.771 29.0149C78.7722 71.2975 106.556 94.9001 55.8326 136.96L1 181.167L61.9826 256.808C61.9826 256.808 114.409 213.963 116.182 212.534Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7149 213.48C64.7196 214.127 64.6739 214.711 64.7374 215.29C64.917 217.026 65.7453 218.63 67.0568 219.782C67.4989 220.246 68.0698 220.567 68.6962 220.705C69.3225 220.842 69.9758 220.789 70.572 220.552C71.7481 220.08 72.7763 219.301 73.5494 218.297C75.7219 215.571 77.7225 212.713 79.5393 209.739C82.2323 205.502 84.8724 201.226 87.5654 196.989C89.0752 194.593 90.7402 192.298 92.5497 190.12C93.6444 188.713 95.0761 187.605 96.7122 186.898C97.7432 186.5 98.8576 186.368 99.9526 186.514C101.048 186.66 102.088 187.08 102.978 187.734C103.689 188.193 103.466 188.198 104.018 187.742C105.728 186.363 107.445 184.98 109.13 183.57L109.449 183.312L113.274 188.057L112.968 188.304C111.244 189.756 109.52 191.208 107.786 192.647C107.617 192.783 107.644 192.906 107.758 193.124C108.573 194.422 109.069 195.894 109.206 197.42L104.165 198.117C103.958 197.386 103.82 196.65 103.557 195.953C103.179 194.97 102.529 194.115 101.683 193.487C101.29 193.155 100.809 192.943 100.299 192.878C99.7877 192.814 99.2689 192.898 98.8051 193.122C97.7993 193.635 96.9373 194.39 96.2974 195.32C93.5413 199.026 90.9825 202.875 88.6316 206.85C86.0639 210.986 83.5024 215.116 80.8465 219.168C79.6949 220.908 78.4249 222.567 77.0455 224.133C75.6814 225.775 73.8121 226.919 71.7297 227.386C70.7422 227.574 69.7269 227.561 68.7452 227.346C67.7634 227.131 66.8357 226.719 66.018 226.135C65.6756 225.915 65.4708 225.905 65.2052 226.139C63.4477 227.639 61.675 229.12 59.8961 230.605C59.7269 230.742 59.5641 230.873 59.3824 231.02L55.5117 226.219L61.5506 221.35C61.2214 220.583 60.8545 219.845 60.5378 219.068C60.0518 217.795 59.7507 216.459 59.6436 215.1C59.6457 215.052 59.6567 215.004 59.6758 214.96C59.7054 214.921 59.7441 214.89 59.7886 214.869C61.3799 214.382 63.0179 213.939 64.7149 213.48Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M160.491 26.4136L194.404 68.4782",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M143.563 40.061L170.472 73.4372",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M126.581 53.7514L156.149 90.4264",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M115.434 73.2328L136.73 99.6483",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M107.569 95.3224L141.482 137.387",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M100.829 117.375L130.826 154.582",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2246 135.407L111.504 164.282",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg3);
export default __webpack_public_path__ + "static/media/img3.ed2733697535d272597a56e29e4a2751.svg";
export { ForwardRef as ReactComponent };